import React, { useEffect, useState } from "react";

// styles
import Styles from "./account-deletion-policy.module.css";

// ** Components
import PageHeader from "../../components/PageHeader/PageHeader";
import { useSelector } from "react-redux";

export default function AccountDeletionPolicy() {
	const exchangeName = useSelector((state) => state.exchangeCustomization.value.name)

	document.title = `${exchangeName}: Delete Account Policy`

	// ** States
	const [policy, setPolicy] = useState("")

	useEffect(() => {
		// _getPolicies(
		//     (data) => {
		//         console.log(data.data.AccountDeletionPolicy)
		//         setPolicy(data.data.AccountDeletionPolicy?.body || getDefaultPolicy())
		//     },
		//     (err) => {
		//         console.log("Error loading policies, using default")
		//         setPolicy(getDefaultPolicy())
		//     }
		// )
		setPolicy(getDefaultPolicy())
	}, [])

	const getDefaultPolicy = () => {
		return `
			<div class="policy-content">
				<h1 style="color: var(--primary-color); font-size: 24px; margin-bottom: 20px;">WealthTech Crypto</h1>
				<h1 style="color: var(--primary-color); font-size: 24px; margin-bottom: 20px;">Delete Account Policy</h1>
				<p style="font-size: 14px; line-height: 1.6; margin-bottom: 20px; color: #666;">Last updated: 19/08/2025</p>
				
				<p style="font-size: 14px; line-height: 1.6; margin-bottom: 20px;">
					At WealthTechCrypto.com, we understand that circumstances change and you may wish to close your account with us. This policy explains how account deletion works, how your personal data is handled, and what legal requirements may affect the process. It is written in clear terms so you know exactly what to expect.
				</p>

				<h2 style="color: var(--primary-color); font-size: 20px; margin-top: 30px; margin-bottom: 15px;">1. How to Request Account Deletion</h2>
				<p style="font-size: 14px; line-height: 1.6; margin-bottom: 15px;">
					You may request deletion of your account at any time. To make it simple, we provide two secure options:
				</p>
				<ul style="font-size: 14px; line-height: 1.6; margin-bottom: 15px; margin-left: 20px;">
					<li><strong>In-App Deletion:</strong><br/>
					Available directly within the WealthTech Crypto mobile app on both iOS and Android. Simply Login and go to: My Account → Deletion.</li>
					<li><strong>Web Deletion Request:</strong><br/>
					Accessible via our browser version. Login and go to My Account → Deletion.</li>
				</ul>
				<p style="font-size: 14px; line-height: 1.6; margin-bottom: 15px;">
					We may require identity verification and a zero balance on your account before processing your request.
				</p>

				<h2 style="color: var(--primary-color); font-size: 20px; margin-top: 30px; margin-bottom: 15px;">2. What Happens to Your Data</h2>
				<p style="font-size: 14px; line-height: 1.6; margin-bottom: 15px;">
					Once your request has been confirmed, we will begin removing or anonymizing your personal data. This includes your identification details, login credentials, trading history, wallet balances, KYC verification documents, and any communications you have had with our support team. In short, all of the information linked to your active account will be securely erased from our systems.
				</p>

				<h2 style="color: var(--primary-color); font-size: 20px; margin-top: 30px; margin-bottom: 15px;">3. Legal & Regulatory Retention</h2>
				<p style="font-size: 14px; line-height: 1.6; margin-bottom: 15px;">
					Because WealthTechCrypto operates in a regulated financial environment, some information must be kept for a limited time even after your account is deleted. This includes transaction records for tax and reporting purposes, KYC and AML documentation required under EU law, data connected to ongoing investigations or disputes, and certain security and audit logs. Access to this information is strictly limited to compliance and legal teams, and it will be permanently deleted as soon as the retention period expires.
				</p>

				<h2 style="color: var(--primary-color); font-size: 20px; margin-top: 30px; margin-bottom: 15px;">4. Processing Timeline</h2>
				<p style="font-size: 14px; line-height: 1.6; margin-bottom: 15px;">
					As soon as we receive your deletion request, you will automatically receive confirmation that it has been logged. The process will begin within forty-eight (48) hours of verification. From there, the complete removal or anonymization of your data may take up to ninety (90) days. This timeframe allows us to ensure that backups are synchronized, third-party providers are updated, regulatory obligations are reviewed, and security audits are completed.
				</p>
				<p style="font-size: 14px; line-height: 1.6; margin-bottom: 15px;">
					In rare cases, if legal or technical requirements mean that deletion takes longer, we will notify you and keep you informed until the process is complete.
				</p>

				<h2 style="color: var(--primary-color); font-size: 20px; margin-top: 30px; margin-bottom: 15px;">5. Irreversible Action</h2>
				<p style="font-size: 14px; line-height: 1.6; margin-bottom: 15px;">
					Deleting your account is a permanent action. Once the process is complete, all account data is removed and cannot be recovered. You will lose access to any remaining cryptocurrency balances, so please make sure to withdraw funds before submitting your request. If you decide to return in the future, you will need to create a new account from scratch, as past records and history cannot be restored.
				</p>

				<h2 style="color: var(--primary-color); font-size: 20px; margin-top: 30px; margin-bottom: 15px;">7. Updates to this Policy</h2>
				<p style="font-size: 14px; line-height: 1.6; margin-bottom: 15px;">
					We may update this policy from time to time if regulations change or if our internal practices are improved. If the updates are significant, we will notify you directly by email or through an announcement on our platform.
				</p>

				<h2 style="color: var(--primary-color); font-size: 20px; margin-top: 30px; margin-bottom: 15px;">8. Contact Us</h2>
				<p style="font-size: 14px; line-height: 1.6; margin-bottom: 15px;">
					If you have questions about deleting your account, or if you need help completing the process, our dedicated support team is here for you. You can reach us at <a href="mailto:crypto@wealthtech.group" style="color: var(--primary-color);">crypto@wealthtech.group</a>
				</p>
			</div>
		`
	}

	return (
		<div className={Styles.pageContainer}>
			<PageHeader
				title="Delete Account Policy"
				description="Learn about our account deletion process and data handling policies"
			/>

			<div
				className={Styles.policyContent}
				dangerouslySetInnerHTML={{ __html: policy }}
			/>
		</div>
	)
}
